import React, { FC, useState } from 'react';
import { useHistory } from 'react-router';

import { QueryTable } from '@app/components/common/table/query-table';
import { useApi, useFetchData } from '@app/hooks';
import { ROLES } from '@app/navigation/types';
import { usePermissions } from '@app/hooks/use-permissions';

import { useColumns } from './columns';
import { NewOutlet } from '../../../api/models/outlet';
import { UnCancelModal } from './uncancel-modal';

const NewOutlets: FC = () => {
  const api = useApi();
  const canEdit = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF] });
  const [fetchData] = useFetchData<NewOutlet>({ method: api.acb.getNewOutlets });
  const history = useHistory();
  const [showUncancelModal, setShowUncancelModal] = useState(false);
  const [uncancelOutletId, setUncancelOutletId] = useState<number>();
  const onUncancelClick = (id: number) => {
    setUncancelOutletId(id);
    setShowUncancelModal(true);
  };

  const columns = useColumns(canEdit, onUncancelClick);
  return (
    <>
      <QueryTable<NewOutlet>
        title="Новые ТТ"
        columns={columns}
        fetchData={fetchData}
        initialSort={{ name: 'id', direction: 'desc' }}
        onCreateClick={() => history.push('/acl/new-outlets/create')}
        canDownload
      >
        <UnCancelModal
          isOpen={showUncancelModal}
          onClose={() => setShowUncancelModal(false)}
          outletId={uncancelOutletId}
        />
      </QueryTable>
    </>
  );
};

export default NewOutlets;
